/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import { IItemsLabelsData } from './cus-support-form.props.autogenerated';

type NullishString = string | null;

export interface ICusSupportFormData {
    actionResponse: { text: string };
}

export interface IFormData {
    name: NullishString;
    email: NullishString;
    description: NullishString;
    orderNumber: NullishString;
    phoneNumber: NullishString;
    size: NullishString;
    color: NullishString;
    itemNumber: NullishString;
    topic: SupportFormOption;
    isLoading: boolean;
    items: IItem[] | [];
}

export interface IItem {
    color: string;
    itemNumber: string;
    size: string;
    image: File | null;
}

export enum SupportFormOption {
    MissingItem = 0,
    OrderNotReceived = 1,
    WrongSizeColor = 2,
    DamagedItem = 3,
    PlacingOrder = 4,
    Other = 5
}

export const SupportFormOptionLabels = (translatedLabels: IItemsLabelsData): { [key in SupportFormOption]: string } => ({
    [SupportFormOption.MissingItem]: translatedLabels.missingItem!,
    [SupportFormOption.OrderNotReceived]: translatedLabels.orderNotReceived!,
    [SupportFormOption.WrongSizeColor]: translatedLabels.wrongSizeColor!,
    [SupportFormOption.DamagedItem]: translatedLabels.damagedItem!,
    [SupportFormOption.PlacingOrder]: translatedLabels.placingOrder!,
    [SupportFormOption.Other]: translatedLabels.other!
});
